import React, { useEffect } from "react";
import styled from "styled-components";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { usePostHog } from "posthog-js/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { StatusStateEnum, TopicFootprintTypeEnum } from "~/types/enums";
import Modal from "~/components-shared/Modal";
import toastsActionCreators from "~/store/toasts/actions";
import { Alert } from "~/components-shared";
import moment from "moment";
import topicFootprintSelectors from "~/store/topicFootprints/selectors";
import topicFootprintSchema from "~/forms/TopicFootprintForm/topicFootprintSchema";
import TopicFootprintForm from "~/forms/TopicFootprintForm";
import topicFootprintActionCreators from "~/store/topicFootprints/actions";
const Sticky = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;
`;
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;

  .toolbar {
    position: sticky;
    top: -5px;
    z-index: 1;
  }
`;
const TopicFootprintCreateModal = () => {
  const {
    t
  } = useTranslation();
  const topicId = useSelector(topicFootprintSelectors.getSelectedData);
  const action = useSelector(topicFootprintSelectors.getAction);
  const status = useSelector(topicFootprintSelectors.getStatusByFootprint("+"));
  const error = useSelector(topicFootprintSelectors.getErrorByFootprint("+"));
  const dispatch = useDispatch();
  const posthog = usePostHog();
  const defaultValues = {
    type: TopicFootprintTypeEnum.TEXT,
    text: "",
    files: [],
    date: moment().toISOString()
  };
  const {
    handleSubmit,
    control,
    reset
  } = useForm({
    resolver: yupResolver(topicFootprintSchema),
    defaultValues
  });
  useEffect(() => {
    if (!action) {
      reset(defaultValues);
    }
  }, [action]);
  const onSubmit = handleSubmit(data => {
    dispatch(topicFootprintActionCreators.createStarted(topicId, data, _ref => {
      let {
        data: newTopic
      } = _ref;
      if (newTopic) {
        dispatch(toastsActionCreators.pushed({
          severity: "success",
          message: t("TopicFootprintCreateModal.footprintCreated"),
          timeout: 10000
        }));
        reset(defaultValues);
      }
    }));
    posthog.capture(`Topic Footprint Create – Save`, {
      ...data
    });
  });
  const onCancel = () => {
    dispatch(topicFootprintActionCreators.actionChanged(null, null));
    posthog.capture(`Topic Footprint Create – Cancel`);
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("TopicFootprintCreateModal.createFootprint"),
    onClose: onCancel,
    fullWidth: true,
    maxWidth: "600px"
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Sticky, null, /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error)), /*#__PURE__*/React.createElement(TopicFootprintForm, {
    control: control
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: onCancel,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("TopicFootprintCreateModal.saveFootprint")))));
};
export default TopicFootprintCreateModal;